export default __webpack_public_path__ + "cedc3a66a284f9376ad6e6327dc05be6.ttf";